import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useContactGroups } from "../../../../context/ContactGroupsContext";

const AssignGroupModal = ({ isOpen, onClose, groupId, contacts, setContacts }) => {
  const [selectedContactIds, setSelectedContactIds] = useState([]);
  const { addContactsToGroup, fetchGroups } = useContactGroups();

  useEffect(() => {
    if (isOpen && groupId) {
      setSelectedContactIds([]);
    }
  }, [isOpen, groupId]);

  if (!isOpen || !groupId) return null;

  const toggleContact = (id) => {
    setSelectedContactIds((prev) =>
      prev.includes(id) ? prev.filter((cid) => cid !== id) : [...prev, id]
    );
  };

  const isAllSelected = contacts.length > 0 && selectedContactIds.length === contacts.length;

  const toggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedContactIds([]);
    } else {
      setSelectedContactIds(contacts.map((contact) => contact.id));
    }
  };

  const handleAssign = async () => {
    if (selectedContactIds.length === 0) {
      toast.warn("Please select at least one contact");
      return;
    }

    try {
      await addContactsToGroup(groupId, selectedContactIds);

      setContacts((prev) =>
        prev.map((contact) =>
          selectedContactIds.includes(contact.id)
            ? {
                ...contact,
                groups: contact.groups?.includes(groupId)
                  ? contact.groups
                  : [...(contact.groups || []), groupId],
              }
            : contact
        )
      );

      await fetchGroups();
      toast.success("Contacts assigned successfully");
      onClose();
      setSelectedContactIds([]);
    } catch (err) {
      toast.error("Failed to assign contacts to group");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white dark:bg-gray-900 p-6 rounded-md w-full max-w-lg max-h-[80vh] overflow-y-auto">
        <h2 className="text-lg font-semibold mb-4 text-gray-800 dark:text-white">
          Assign Contacts to Group
        </h2>

        <div className="mb-2 flex items-center">
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={toggleSelectAll}
            className="w-4 h-4 mr-2"
          />
          <label className="text-gray-800 dark:text-white">Select All</label>
        </div>

        <div className="space-y-2 max-h-80 overflow-y-auto">
          {contacts.map((contact) => (
            <div key={contact.id} className="flex items-center justify-between p-2 border rounded">
              <label className="flex items-center space-x-2 text-gray-800 dark:text-white">
                <input
                  type="checkbox"
                  checked={selectedContactIds.includes(contact.id)}
                  onChange={() => toggleContact(contact.id)}
                  className="w-4 h-4"
                />
                <span>{contact.name} ({contact.email || "No Email"})</span>
              </label>
            </div>
          ))}
        </div>

        <div className="flex justify-end space-x-2 mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 dark:bg-gray-700 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleAssign}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Assign Selected
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignGroupModal;
